@if (selectedPeriode !== 0 && (werknemerEntity$ | async) && (loonstaatEntity$ | async)) {
  <snelstart-ui-button (click)="this.showDialog()"
                       icon="plus"
                       class="custom-input-150"
                       type="secondary">
    Specificeer
  </snelstart-ui-button>

  <snelstart-ui-dialog-definition [(visible)]="dialogVisible"
                                  [useTitleBorder]="true"
                                  id=dialog
                                  size="lg"
                                  title="Variabele vergoedingen">
    <snelstart-ui-dialog-body>
      <snelstart-ui-dialog-header-content>
        Over de periode van {{this.startDatePeriode | date: 'dd-MM-yyyy'}} tot en met {{this.endDatePeriode | date:'dd-MM-yyyy'}}.
      </snelstart-ui-dialog-header-content>
      <div class="row">
        <form [formGroup]="lijstFg">
          <div formArrayName="variabeleVergoedingen">
            @for (item of getVariabeleVergoedingen.controls; track item; let i = $index) {
              <div [formGroupName]="i">
                @if (showInPeriode(item.getRawValue())) {
                <div class="row mb-0.5">
                  <div class="col-auto">
                    <snelstart-ui-select-form-control
                      [formControl]="item.controls.component"
                      [label]="i===0 ? 'Type vergoeding' : ''"
                      [options]="optionsComponenten"
                      class="custom-input-250"
                      id="component">
                    </snelstart-ui-select-form-control>
                  </div>
                  <div class="col-auto">
                    <snelstart-ui-text-form-control
                      [formControl]="item.controls.displayValue"
                      [label]="i===0 ? 'Omschrijving' : ''"
                      placeholder="Omschrijving"
                      class="custom-input-250"
                      >
                    </snelstart-ui-text-form-control>
                  </div>
                  <div class="col-auto">
                    <snelstart-ui-number-form-control
                      (change)="saveForm()"
                      [formControl]="item.controls.bedrag"
                      [label]="i===0 ? 'Bedrag' : ''"
                      [prefix]="'€'"
                      [showAllDecimals]="true"
                      align="right"
                      class="custom-input-150"
                      >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-auto">
                    <snelstart-ui-button
                      (click)="verwijderRij(i)"
                      [class]="i === 0 ? 'firstrowbutton' : ''"
                      icon="trash"
                      id="buttonDelete"
                      size="medium"
                      type="secondary">
                    </snelstart-ui-button>
                  </div>
                </div>
                }
              </div>
            }
          </div>
        </form>
      </div>

      <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button pb-3" icon="plus"
                           id="cancel4"
                           type="link">Nieuwe vergoeding toevoegen
      </snelstart-ui-button>
    </snelstart-ui-dialog-body>

    <snelstart-ui-dialog-buttons class="d-flex">
      <snelstart-ui-button (click)="dialogVisibleChange.emit(false)" btn-x class="me-1" id="cancel" type="secondary">
        Annuleren
      </snelstart-ui-button>
      <snelstart-ui-button (click)="saveForm()" icon="check" id="save" type="primary">
        Opslaan
      </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
  </snelstart-ui-dialog-definition>
}

